import React, { useEffect, useState } from "react";
import { Message } from "semantic-ui-react";
import { ResumenVecino } from "../../components/Vecino/ResumenVecino";
import { ItemLista } from "../../components/Solicitud/ItemLista";
import { LoadingSpinner } from "../../components/Otros/LoadingSpinner";
import { solicitudesPorRut } from "../../utils/Datos";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { selectUser,logout, login } from "../../reducers/userSlice";
import Swal from "sweetalert2";
import { Alerta } from "../../components/Otros/Alerta";
import SatisfactionSurveyBanner from "../../components/Otros/SatisfactionSurveyBanner";

export const Home = () => {
  const error = localStorage.getItem("error");
  const info = localStorage.getItem("info");
  const exito = localStorage.getItem("exito");
  const dispatch = useDispatch();


  const user = useSelector(selectUser);
  const [solicitudes, setsolicitudes] = useState([])
  const [cargando, setcargando] = useState(true)
  const [cantidadpendientes, setcantidadpendientes] = useState(0)
  const [cantidadTotal, setcantidadTotal] = useState(0)

  const [verSoloPendientes, setverSoloPendientes] = useState(true)

    useEffect(() => {

    if (user != null) {
      if (user.user.perfil_completo != 1) {
        window.location.href = "/completarPerfil?causa=datos-incompletos";
      }
    }
  }, [user]);

  useEffect(() => {
    const rut=user.user.run;
    //const rut='20649027-6';
    solicitudesPorRut(rut).then((respuesta)=>{
      setcargando(false);
      if (respuesta.status) {
        console.log('TODAS SOLICITUDES',respuesta.datos);

        setsolicitudes(respuesta.datos.reverse());
        setcantidadpendientes(respuesta.datos.filter(solicitud => solicitud.isAcusaReceive === false && solicitud.state === 'EN PROCESO' || solicitud.state === 'SIN ASIGNAR' || (solicitud.isAcusaReceive===false && solicitud.state==='CERRADA')).length);
        setcantidadTotal(respuesta.datos.length);
      }else{
        Swal.fire({
          icon:'error',
          title:'Ha ocurrido un error',
          text:respuesta.errores[0]
        })
      }
    })
  }, [user])



  return (
    <div className="container post">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <ResumenVecino
                cantidadPendientes={cantidadpendientes}
                cantidadTotal={cantidadTotal}
                setverSoloPendientes={setverSoloPendientes}
              ></ResumenVecino>
            </div>
          </div>

          <SatisfactionSurveyBanner></SatisfactionSurveyBanner>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-12 mb-4">
          {
            solicitudes.length>0 &&
            <div className="card  mb-4">
              <div className="card-body">
                <h3 className="text-center text-uppercase">
                  {verSoloPendientes ? `SOLICITUDES PENDIENTES` : `TODAS LAS SOLICITUDES`}
                </h3>
              </div>
            </div>
          }

          {
            cargando ?
            <LoadingSpinner texto={'Cargando solicitudes pendientes...'}/>
            : solicitudes.length<1 ?
            <Alerta tipo="primary" titulo="Información" texto="No tienes solicitudes pendientes para mostrar.">
            </Alerta>
            :
            verSoloPendientes ?
            solicitudes //MOSTRAR SOLO PENDIENTES
            .filter(solicitud => solicitud.isAcusaReceive === false && solicitud.state === 'EN PROCESO' || solicitud.state === 'SIN ASIGNAR' || (solicitud.isAcusaReceive===false && solicitud.state==='CERRADA')).length<1 ?
            <Alerta tipo="primary" titulo={'Atención'} texto={'No tienes solicitudes pendientes para mostrar'}></Alerta>
            :
            solicitudes //MOSTRAR SOLO PENDIENTES
            .filter(solicitud => solicitud.isAcusaReceive === false && solicitud.state === 'EN PROCESO' || solicitud.state === 'SIN ASIGNAR' || (solicitud.isAcusaReceive===false && solicitud.state==='CERRADA'))
            .map(solicitud => (
               <ItemLista solicitud={solicitud}></ItemLista>
            )) : //MOSTRAR TODAS
            solicitudes
            .map(solicitud => (
               <ItemLista solicitud={solicitud}></ItemLista>
            ))
          }


        </div>
      </div>
    </div>
  );
};
